module.exports = "<div class=\"out-of-stock-indicator\" ng-if=\"$ctrl.visible\">\n  <h3>{{$ctrl.indicatorTXT | translate}}</h3>\n</div>\n";